import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
export function replaceAll(str, find, replace) {
  return str.replace(new RegExp(find, "g"), replace);
}
export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
export function formatAddress(streetName, streetNumber, cityName, provinceAcronym) {
  var components = [];
  if (streetName && streetName !== "ND") {
    if (streetNumber && streetNumber !== "ND" && streetNumber !== "0") components.push("".concat(streetName, " ").concat(streetNumber));else components.push(streetName);
  }
  if (cityName && provinceAcronym) {
    components.push("".concat(cityName, " (").concat(provinceAcronym, ")"));
  } else {
    components.push(cityName);
  }
  var address = components.filter(component => !!component).join(", ");
  return capitalizeFirstLetter(address);
}
export function decodeTextWithEntities(strWithEntities) {
  if (!strWithEntities) return "";
  var a = document.createElement("span");
  a.innerHTML = strWithEntities;
  return a.textContent || "";
}
/**
 * Replaces a given string with the values of the object
 * @param str string to replace
 * @param mapObj Object whose keys are the tokens to replace and whose values are the ones that will replace that matched token
 * e.g. replaceAllToken('Here we go', {Here: Now, go: eat}) returns 'Now we eat'
 * */
export function replaceAllTokens(str, mapObj) {
  var re = new RegExp(Object.keys(mapObj).map(key => key.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&")).join("|"), "gi");
  return str.replace(re, function (matched) {
    return mapObj[matched.toLowerCase()];
  });
}
export function cleanASCII(str) {
  return str.replace(/[\uA78C\uA78B]/g, "'").replace(/[^\x00-\x7F]/g, "");
}
export var stringToHyphened = function stringToHyphened() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  if (!str || !str.trim()) return "";
  str = str.trim();
  return str.replace(" ", "-").toLowerCase();
};